// const environment = {
//     apiUrl: 'http://localhost:4000/api/v1/',
//     storageUrl: 'http://localhost:4000/documents',
// };

// const environment = {
//     "apiUrl": "https://dashboard-24304.nodechef.com/api/v1/",
//     "storageUrl": "https://dashboard-24304.nodechef.com/documents"
// }

const environment = {
    apiUrl: 'https://dashboardapp2-27872.nodechef.com/api/v1/',
    storageUrl: 'https://dashboardapp2-27872.nodechef.com/documents',
};

export default environment;
